import serviceBase from "./serviceBase";
import { EndPoint } from "../appConfig";
import Cache from "../cache";

const cache = new Cache();
var RoomService = Object.create(new serviceBase(EndPoint.Room));

/**
 * 登録されている、会議室を取得します。
 */
RoomService.getRooms = function(forced) {
  var self = this;
  if (!forced && cache.rooms) return Promise.resolve(cache.rooms);
  return new Promise(resolve => {
    self.get().then(rooms => {
      cache.rooms = rooms;
      resolve(rooms);
    });
  });
};

/**
 * 登録されている、会議室を取得します。
 */
RoomService.getMatchRooms = function(criterias) {
  var _this = this;
  return new Promise(resolve => {
    _this.getRooms().then(rooms => {
      var matchedRooms = rooms;
      for (var key in criterias) {
        var criteria = criterias[key];
        var searchMethod;
        if (criteria.selected.length === 0) continue;
        switch (criteria.type) {
          // 単一
          case 0:
            searchMethod = room =>
              room.attributeItems.some(a => a.id === criteria.selected[0]);
            break;
          // OR
          case 1:
            searchMethod = room =>
              criteria.selected.some(c =>
                room.attributeItems.some(a => a.id === c)
              );
            break;
          // AND
          case 2:
            searchMethod = room =>
              criteria.selected.every(c =>
                room.attributeItems.some(a => a.id === c)
              );
            break;
          default:
            searchMethod = () => {
              return false;
            };
            break;
        }
        matchedRooms = matchedRooms.filter(r => searchMethod(r));
      }
      resolve(matchedRooms);
    });
  });
};
export default RoomService;
